<li
  [class]="setCheckForErrorIndication(7) ? ((pickStoryImageLoad || imageUploadInProgress)
              ? 'leadMedia errorInput loadwaiting' : 'leadMedia errorInput') : ((pickStoryImageLoad || imageUploadInProgress) ? 'leadMedia loadwaiting' : 'leadMedia')"
  id="leadMedia">
  <ng-container *ngIf="(storyData.ogMedia && storyData.ogMedia.elements && (storyData.ogMedia.elements.length > 0))">
    <!--div class="element-module" #leadElement [leadMedia]="false" [leadMediaGif]="false" [EditMode]="storyEditMode" [id]="storyData.ogMedia.elements[0]"
                    [cardId]="storyData.ogMedia.elements[0]" (deleteCardfn)="deleteImageCardEmit($event)"
                    (updateContentOnParent)="getUpadtedElementContent($event)" [preLoadedcardData]="serveElementContent(storyData.ogMedia.elements[0])"
                    (sendWordCountToStory)="getWordCount($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
                    [hideDragger]="true" (currentcardfn)="currentCardId(null)" (previousFocusEmit)="focusOnElement($event, 'lead|up')"
                    (nextFocusEmit)="focusOnElement($event, 'lead|down')" (incrementPendingRequest)="increasePendingCount()"
                    (decrementPendingRequest)="decreasePendingCount($event)" [showErrorForPublish]="setCheckForErrorIndication(7)"
                    (scrollOut)="scr($event)" (storySave)="autoSaveRequest($event)" [storytype]="storyType" [leadVideoThumbnail]="true"
                    (sendVideoCaption)="updateVideoCaption($event)" (sendVideoImageCaption)="updateVideoImageCaption($event)"
                    (sendReplaceVideoImage)="replacingVideoThumbnail($event)"
                  -->
    <div #ogElement class="element-module" [leadMedia]="false" [leadMediaGif]="false" [EditMode]="storyEditMode"
      [id]="storyData.ogMedia.elements[0]" [cardId]="storyData.ogMedia.elements[0]"
      (deleteCardfn)="deleteImageCardEmit($event)" (updateContentOnParent)="getUpadtedElementContent($event)"
      [preLoadedcardData]="serveElementContent(elementId)" (sendWordCountToStory)="getWordCount($event)"
      (childKeyDown)="childKeyDownEventCatcher($event)" [hideDragger]="true" (currentcardfn)="currentCardId($event)"
      [showErrorForPublish]="setCheckForErrorIndication(7)" (scrollOut)="scr($event)"
      (storySave)="autoSaveRequest($event)" [storytype]="storyType" [ogImage]="true">
    </div>
  </ng-container>
  <ng-container *ngIf="(pickStoryImageLoad || imageUploadInProgress)">
    <div class="imagepreloader">
      <div class="a" style="--n: 5;">
        <div class="dot dot1" style="--i: 0;"></div>
        <div class="dot dot2" style="--i: 1;"></div>
        <div class="dot dot3" style="--i: 2;"></div>
        <div class="dot dot4" style="--i: 3;"></div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!(storyData.ogMedia && storyData.ogMedia.elements && (storyData.ogMedia.elements.length > 0))
                  && storyEditMode && !(pickStoryImageLoad || imageUploadInProgress)">
    <label [style.visibility]="focusOnOgMedia === true ? 'visible' : 'hidden'">OG Media</label>
    <div class="dataField" (focus)="focusOnOgMedia = true;focusedCard = null"
      (focusout)="focusOnOgMedia = (leadMediaImageToggle ? true : false)" (mouseenter)="focusOnOgMedia = true"
      (mouseleave)="focusOnOgMedia = (leadMediaImageToggle ? true : false)" tabindex="3">
      <ul [ngClass]="{'z-high': leadMediaImageToggle}" class="leadMediaIcon">
        <li class="spImg_story">
          <span class="i_image" [ngClass]="{'active' : leadMediaImageToggle}" (click)="listClick()">
            <i class="icon-image"></i>
          </span>
          <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
            <div class="blockContain">
              <div class="uploadimage">
                <i class="icon-upload"></i>
                <div class="upload-btn-wrapper">
                  <span class="btn">Upload a new Image</span>
                  <input type="file" name="myfile" accept="image/*"
                    (change)="onFileChangeSingle($event, 'leadMedia')" />
                </div>
              </div>
              <div class="pickimage">
                <i class="icon-image-library"></i>
                <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
                <div class="lightBox block" *ngIf="isLightbox">
                  <div class="headerLight">
                    <div class="close fl spImg" (click)="disableshowGallery()"></div>
                  </div>
                  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="getLeadMediaId($event)"
                    *ngIf="isPhotopopup"></div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </ng-container>
</li>
<div [ngClass]="{'block': leadMediaImageToggle}" (click)="leadMediaImageToggle = false" class="closebg"></div>
<div class="image-cropper" *ngIf="showCropper" [cropperImageUrl]="cropperImageUrl" [storyType]="storyData.type"
  [thumborCompressed]="thumborCompressed" (finish)="finishCropping($event)" (cancel)="cancelCropping($event)"
  [isImageLead]="false" [verticalImageFlag]="verticalImageFlag" [ogImage]="true"></div>